import {ActionsSubject} from '@ngrx/store';
import {CustomDispatcher} from './custom-dispatcher.service';

export const CUSTOM_DISPATCHER = {
    provide: new ActionsSubject(),
    useClass: CustomDispatcher
};
